var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import React from 'react';
import { A } from 'shared-assets/components/Elements';
var Wrapper = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 14px;\n"], ["\n  font-size: 14px;\n"])));
export default function AuthorizationDisclaimer() {
    return (React.createElement(Wrapper, null,
        "This requires the Credit Card Authorization Form. Engage customers can authorize cards for use by sending the Credit Card Authorization Form via Patient Intake. All other customers can",
        ' ',
        React.createElement(A, { target: "_blank", href: "https://cdn.prd.cloud.tebra.com/websitehelp/documents/payments/Credit_Card_Auth_Form_PDF.pdf" }, "download the form"),
        "."));
}
var templateObject_1;
